import { Stack } from "@similarweb/ui-components/foundations";

import type { IScoringRuleBusinessContextDto } from "app/pages/sales-intelligence/sub-modules/signals/types/scoring-config";

import { WizardLimitedTextareaField } from "../WizardLimitedTextareaField";
import { WizardStepHeading } from "../WizardStepHeading";

const CONTEXT_MAX_LENGTH = 100;
const ACTION_MAX_LENGTH = 100;

type Props = {
    value: IScoringRuleBusinessContextDto;
    onChange: (next: IScoringRuleBusinessContextDto) => void;
};

export const Step2BusinessContext = ({ value, onChange }: Props) => {
    return (
        <Stack
            gap="24px"
            width="100%"
            data-automation="scoring-rule-wizard.step-context"
        >
            <WizardStepHeading headingKey="si.pages.score_settings.wizard.step2.heading" />

            <WizardLimitedTextareaField
                labelKey="si.pages.score_settings.wizard.step2.context.label"
                placeholderKey="si.pages.score_settings.wizard.step2.context.placeholder"
                value={value.translation ?? ""}
                maxLength={CONTEXT_MAX_LENGTH}
                onChange={(translation) => onChange({ ...value, translation })}
                counterDataAutomation="scoring-rule-wizard.context-counter"
            />

            <WizardLimitedTextareaField
                labelKey="si.pages.score_settings.wizard.step2.action.label"
                placeholderKey="si.pages.score_settings.wizard.step2.action.placeholder"
                value={value.actionItem ?? ""}
                maxLength={ACTION_MAX_LENGTH}
                onChange={(actionItem) => onChange({ ...value, actionItem })}
                counterDataAutomation="scoring-rule-wizard.action-counter"
            />
        </Stack>
    );
};
